import { Popover } from 'ant-design-vue';
import { h, render } from 'vue';
import type { Directive } from 'vue';
import { getTranslations } from '@mts/locales/helper';
import { PADMode } from '@mts/utils/env';

const langTipsDirective: Directive = {
  mounted(el) {
    const lanKey = el.getAttribute('data-lang-key');
    if (!lanKey || PADMode) return;

    el.style.cursor = 'pointer';
    //当前键盘command+鼠标点击时显示
    el.addEventListener('click', async (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.stopPropagation();

        const res = await getTranslations(lanKey);
        const VNode = h(Popover, {
          open: true,
          placement: 'right',
          destroyTooltipOnHide: true,
          content: h(
            'div',
            { class: 'font-500 text-16px', style: { 'min-width': '80px', color: '#ff7800' } },
            Object.values(res).map((value) => h('div', value)),
          ),
        });
        render(VNode, el);

        document.addEventListener(
          'keyup',
          () => VNode.component?.props?.open && (VNode.component.props.open = false),
          { once: true },
        );
      }
    });
  },
};

export default langTipsDirective;
